import React from "react";
import {
  VisibilityIcon,
  VisibilityOffIcon,
  IconButton,
  InputAdornment,
  makeStyles,
} from "../helper";
import ChallanBaseInput from "./ChallanBaseInput";

const useStyles = makeStyles((theme) => ({
  adornment: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    backgroundColor: "white",
    height: 55,
    width: 50,
    marginLeft: theme.spacing(-4),
    marginRight: theme.spacing(-1.625),
    borderRadius: theme.spacing(0, 4, 4, 0),
  },
}));

export default function ChallanPasswordInput({ ...rest }) {
  const classes = useStyles();
  const [visibility, setVisibility] = React.useState(false);

  /**
   * Stops propagation
   * @param {Object} event event object
   */
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  /**
   * Showes password in text format
   */
  const handleClickShowPassword = () => {
    setVisibility((prev) => !prev);
  };

  return (
    <ChallanBaseInput
      type={visibility ? "text" : "password"}
      endAdornment={
        <div className={classes.adornment}>
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
              sx={{ ml: "-4px" }}
            >
              {visibility ? <VisibilityIcon /> : <VisibilityOffIcon />}
            </IconButton>
          </InputAdornment>
        </div>
      }
      {...rest}
    />
  );
}
